/**
 * The only place that knows where the CRM backend is and how to get the signed-in person's token.
 * Edit these two things; everything else (crmApi, CrmBackend, CrmExplorer) reads them.
 *
 * baseUrl: the gateway. In production https://crm.cilpron.com. The browser calls it directly, so the VPS `.env`
 *          must list your front-end origin in CRM_CORS_ORIGIN (or CRM_CORS_ORIGIN_2), otherwise every call fails with a CORS error.
 * getToken: the bearer token from your central auth API. CRM.tsx reads it from localStorage "authToken"; so does this.
 *           The token must carry the claims the CRM expects (tenant_id as a GUID, sub, the permissions). That is set by the auth API, not here.
 */
export const CRM_BASE_URL: string = "https://crm.cilpron.com";

export const getCrmToken = (): string | undefined => {
  try { return localStorage.getItem("authToken") ?? undefined; } catch { return undefined; }
};

/** Language sent as Accept-Language so validation messages come back translated. */
export const CRM_LANGUAGE = "en";